import moment from 'moment/moment';

export const planFactHelper = (planned, actual, isPlanFact) => {
    let isNotEqualDate = false;
    let isNotEqualDays = false;
    let isRedDate = false;
    let isRedDays = false;

    if (isPlanFact) {
        isNotEqualDate =
            moment(planned.start_date).hour(0).minute(0).seconds(0).format() !==
            moment(actual.start_date).hour(0).minute(0).seconds(0).format();
        isRedDate = moment(planned.start_date)
            .hour(0)
            .minute(0)
            .seconds(0)
            .isBefore(moment(actual.start_date).hour(0).minute(0).seconds(0));
        isNotEqualDays = +planned.days_count !== +actual.days_count;
        isRedDays = +planned.days_count < +actual.days_count;
    }

    return {
        isNotEqualDate,
        isNotEqualDays,
        isRedDate,
        isRedDays,
    };
};
